<core-ui-loader-base [withPadding]="false" [sizePx]="loaderSizePx"></core-ui-loader-base>

<div *ngIf="text" class="core-ui-loading-overlay__text">
    {{ text }}
</div>